/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecord } from './ActorActivityRecord';
import {
    ActorActivityRecordFromJSON,
    ActorActivityRecordFromJSONTyped,
    ActorActivityRecordToJSON,
    ActorActivityRecordToJSONTyped,
} from './ActorActivityRecord';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface StudioActivityDay
 */
export interface StudioActivityDay {
    /**
     * 
     * @type {Date}
     * @memberof StudioActivityDay
     */
    date: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof StudioActivityDay
     */
    totalCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof StudioActivityDay
     */
    isTruncated: boolean;
    /**
     * 
     * @type {Array<ActorActivityRecord>}
     * @memberof StudioActivityDay
     */
    records: Array<ActorActivityRecord>;
}

/**
 * Check if a given object implements the StudioActivityDay interface.
 */
export function instanceOfStudioActivityDay(value: object): value is StudioActivityDay {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('isTruncated' in value) || value['isTruncated'] === undefined) return false;
    if (!('records' in value) || value['records'] === undefined) return false;
    return true;
}

export function StudioActivityDayFromJSON(json: any): StudioActivityDay {
    return StudioActivityDayFromJSONTyped(json, false);
}

export function StudioActivityDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudioActivityDay {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'totalCount': ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'isTruncated': json['isTruncated'],
        'records': ((json['records'] as Array<any>).map(ActorActivityRecordFromJSON)),
    };
}

export function StudioActivityDayToJSON(json: any): StudioActivityDay {
    return StudioActivityDayToJSONTyped(json, false);
}

export function StudioActivityDayToJSONTyped(value?: StudioActivityDay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'].toISOString().substring(0,10),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'isTruncated': value['isTruncated'],
        'records': ((value['records'] as Array<any>).map(ActorActivityRecordToJSON)),
    };
}

